<script>
import $ from "jquery"
import {ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {useStore} from "vuex";

export default {
  name: "WalletPage",
  components: {LoadingPage},
  setup() {

    let store = useStore()
    let loading = ref(false)
    let loading_pic = ref(false)

    let page = ref('inventory')
    let dialog = ref(false)
    let show_cheque = ref({
      action: false,
      src: null
    })
    let details_card = ref (false)

    let history = ref([])
    let cheque_history = ref([])
    let cards = ref(store.state.Cards)
    let wallet = ref(0)

    let select_card = ref(null)

    let add_card = ref({
      name: '',
      bankname: '',
      shaba: '',
      account: '',
      card: '',
    })

    let inc_wallet = ref({
      price: null,
      action: null,
      pic: null,
    })

    let show_pic = ref(null)

    function my_wallet() {

      loading.value = true
      FreeWorld.Heisenberg({action:'wallets'} , 'info' , true).then((res)=>{

        loading.value = false
        history.value = res.data.wallets
        wallet.value = res.data.wallet
        history.value.forEach((item)=>{
          if (item.cheque) cheque_history.value.push(item)
        })

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , my_wallet)
      })

    }
    my_wallet()


    function open_dialog(action , type , item) {

      if (type){
        details_card.value = true
        add_card.value = {
          name: item.name,
          bankname: item.bankname,
          shaba: item.shaba,
          account: item.account,
          card: item.card,
        }
      }

      if (action){

        $("#dialog").removeClass('animate__fadeOut').addClass('animate__fadeIn')
        dialog.value = !dialog.value

      }else {

        $("#dialog").removeClass('animate__fadeIn').addClass('animate__fadeOut')
      setTimeout(()=>{
        add_card.value = {
          name: '',
          bankname: '',
          shaba: '',
          account: '',
          card: '',
        }
      dialog.value = !dialog.value
        details_card.value = false
      },700)

      }

    }

    function add_cards() {

      if (add_card.value.name.trim().length === 0){Swals.Fault('لطفا نام صاحب کارت را وارد کنید!');return false}
      if (add_card.value.bankname.trim().length === 0){Swals.Fault('لطفا نام بانک را وارد کنید!');return false}
      if (add_card.value.shaba.length === 0){Swals.Fault('لطفا شماره شبا را وارد کنید!');return false}
      if (add_card.value.account.length === 0){Swals.Fault('لطفا شماره حساب را وارد کنید!');return false}
      if (add_card.value.card.length === 0){Swals.Fault('لطفا شماره کارت را وارد کنید!');return false}

      loading.value = true
      FreeWorld.Heisenberg(add_card.value , 'add_card' , true).then((res)=>{

        loading.value = false
        if (res.data.status === 'ok'){
          store.commit('set_Cards' , res.data.cards)
          cards.value = store.state.Cards
          Swals.Done('شماره کارت شما با موفقیت ثبت شد')
          open_dialog(false)
        }else {
          Swals.Fault('متاسفانه شماره کارت شما ثبت نشد!')
        }

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , add_cards)
      })

    }

    function delete_cart(item) {

      Swals.Question('آیا میخواهید این کارت را حذف کنید؟' , 'حذف کارت').then((res)=>{
        if (res.isConfirmed){

          loading.value = true
          FreeWorld.Heisenberg({action:'card_delete',card_id:item.id} , 'info').then((res)=>{

            loading.value = false
            if (res.data.status === 'ok'){
              Swals.Done('کارت مورد نظر شما با موفقیت حذف شد')

              $("#Card" + item.id).removeClass('animate__fadeInDown').addClass('animate__backOutDown')
              setTimeout(()=>{
                store.commit('delete_Card' , item)
                // cards.value = store.state.Cards
              },500)

            }else {
              loading.value = false
              Swals.Fault('متاسفانه کارت مورد نظر شما حذف نشد!')
            }

          }).catch((res)=>{
            Swals.Catch(res , delete_cart)
          })

        }
      })

    }

    function Settlement_request() {

      if (wallet.value === 0){Swals.Fault('کیف پول شما خالی است!');return false}
      if (cards.value.length === 0){Swals.Fault('جهت تسویه اول اطلاعات کارت بانکی خود را وارد کنید');return false}
      if (select_card.value === null){Swals.Fault('لطفا یکی از کارت های خود را جهت تسویه انتخاب کنید');return false}

      loading.value = true
      FreeWorld.Heisenberg({card_id:select_card.value},'add_checkout' , true).then((res)=>{

        loading.value = false
      if (res.data.status === 'ok'){
        Swals.Done('درخواست تسویه شما با موفقیت ثبت شد')
        select_card.value = null
      }else {
        Swals.Fault('متاسفانه درخواست تسویه شما ثبت نشد!')
        select_card.value = null
      }

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , Settlement_request)
      })

    }
    
    function open_cheque(pic) {
      
      if (!show_cheque.value.action){
        $("#img_cheque").addClass('animate__fadeIn').removeClass('animate__fadeOut')
        show_cheque.value.src = pic
        show_cheque.value.action = true
      }else {
        $("#img_cheque").addClass('animate__fadeOut').removeClass('animate__fadeIn')
        setTimeout(()=>{
        show_cheque.value.action = false
        },700)
      }
      
    }

    return {

      page,
      history,
      loading,
      cards,
      dialog,
      open_dialog,
      add_card,
      add_cards,
      select_card,
      Settlement_request,
      delete_cart,
      details_card,
      inc_wallet,
      show_pic,
      loading_pic,
      wallet,
      show_cheque,
      open_cheque,
      cheque_history,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div v-if="dialog" @click="open_dialog(false)" class="bg_dialog"></div>
  <div v-if="show_cheque.action" @click="open_cheque" class="bg_dialog"></div>

  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-bold">کیف پول و پرداخت ها</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="p-body my-3">

      <div class="bg-white shadow-custom rounded-4 overflow-hidden">

        <div class="d-flex justify-content-around mb-5 overflow-hidden">

          <div @click="page = 'inventory'" :class="page === 'inventory' ? 'shadow_select rounded-top-4':'' " class="d-flex justify-content-center align-items-center flex-column w-33">
            <div class="d-flex mt-2">
              <img v-if="page === 'inventory' " class="icon_shadow" src="../assets/img/walletm1.png" style="width: 2.5rem;height: 2.5rem">
              <img v-else class="icon_shadow" src="../assets/img/wallet_active.svg" style="width: 2rem;height: 2rem">
            </div>
            <p :class="page === 'inventory' ? 'font-color font-4':'font-color_light font-5' " class="">موجودی </p>
          </div>

          <div @click="page = 'Transactions'" :class="page === 'Transactions' ? 'shadow_select rounded-top-4':'' " class="d-flex justify-content-center align-items-center flex-column w-33 py-1">
            <div class="d-flex mt-2">
              <img v-if="page === 'Transactions' " class="icon_shadow" src="../assets/img/list_active.svg" style="width: 2.5rem;height: 2.5rem">
              <img v-else class="icon_shadow" src="../assets/img/list_not_avtive.svg" style="width: 2rem;height: 2rem">
            </div>
            <p :class="page === 'Transactions' ? 'font-color font-4':'font-color_light font-5' " class="">تراکنش ها</p>
          </div>

          <div @click="page = 'cheque'" :class="page === 'cheque' ? 'shadow_select rounded-top-4':'' " class="d-flex justify-content-center align-items-center flex-column w-33 py-1">
            <div class="d-flex mt-2">
              <img v-if="page === 'cheque' " class="icon_shadow" src="../assets/img/cheque_active.svg" style="width: 2.5rem;height: 2.5rem">
              <img v-else class="icon_shadow" src="../assets/img/cheque_not_active.svg" style="width: 2rem;height: 2rem">
            </div>
            <p :class="page === 'cheque' ? 'font-color font-4':'font-color_light font-5' " class="">چک های پرداختی</p>
          </div>

        </div>



        <div style="min-height: 75vh" v-if="page === 'inventory' " class="p-3">

          <p class="mb-3 font-4 font-color font-bold">موجودی کیف پول</p>

          <div class="shadow-custom font-bold bg-color-blue-light d-flex justify-content-center align-items-center p-3 rounded-3 mb-3">
            <p class="font-4 ms-1 font-color-green fw-bold">{{ wallet.toLocaleString() }}</p>
            <p class="font-5 font-color-green">تومان</p>
          </div>

          <div class="py-3 p-body bg-color-blue-light rounded-4 shadow-custom">

            <div class="d-flex align-items-center justify-content-between mb-3">
              <p class="font-4 font-bold">کارت های من</p>

              <div @click="open_dialog(true)" class="text-decoration-none d-flex align-items-center">
                <img src="../assets/img/add_color.svg" alt="" class="icon_shadow icon-size-2 ml-2">
                <p class="font-5 font-color">افزودن کارت</p>
              </div>
            </div>

            <div class="list_address mb-2">

              <div v-for="item in cards" :key="item.id" :class="select_card === item.id ? 'bg-color text-white':'bg-white font-color' " :id="'Card' + item.id" class="animate__animated animate__fadeInDown shadow-custom rounded-3 p-2 d-flex justify-content-between align-items-center my-3">
                <div @click="select_card = item.id" class="d-flex justify-content-between align-items-center w-75">
                  <img v-if="select_card === item.id" class="icon_shadow icon-size-2" src="../assets/img/credit.png" >
                  <img v-else src="../assets/img/credit.svg" class="icon_shadow icon-size-2">

                  <div class="overflow-hidden mx-1 w-40">
                  <p class="mx-1 font-5 d-flex align-items-center" :class="{'txtoverflow':item.name.length > 10}">{{ item.name }}</p>
                  </div>

                  <div class="overflow-hidden mx-1 w-40">
                  <p class="font-5 d-flex align-items-center" :class="{'txtoverflow':item.bankname.length > 10}">{{ item.bankname }}</p>
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-center w-20">
                  <img @click="open_dialog(true , 'show' , item)" src="../assets/img/backk.png" class="icon_shadow icon-size-2">
                  <img @click="delete_cart(item)" class="icon_shadow icon-size-2" src="../assets/img/delet.png">
                </div>
              </div>

            </div>

            <div class="d-flex justify-content-center">
              <v-btn @click="Settlement_request" class="h-100 bg-red text-white font-4 border-0 rounded-3 p-2 w-60">تقاضای تسویه</v-btn>
            </div>

          </div>
        </div>

        <div v-if="page === 'Transactions' " class="overflow-hidden p-3">

          <div v-if="history.length !== 0" style="height: 70vh" class="overflow-y-scroll">


            <div v-for="item in history" :key="item.id" class="animate__animated animate__fadeInRight my-3 p-body py-3 bg-white rounded-4 shadow-custom">
              <div class="d-flex justify-content-between align-items-center ">
                <div class="d-flex justify-content-center align-items-center">
                  <img v-if="item.type === 'dec' " class="ml-2 icon-size-2" src="../assets/img/mins_red.svg">
                  <img v-else class="ml-2 icon-size-2" src="../assets/img/plusgreen.svg">

                  <div :class="item.type === 'dec' ? 'font-color-red':'font-color-green'" class="d-flex align-items-center">
                  <p class="mx-1 font-4 font-bold">{{ item.amount.toLocaleString() }}</p>
                  <p class="font-5">تومان</p>
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <p class="m-0 ms-2 font-5">{{ item.date }}</p>
                  <p class="m-0 font-5">{{ item.time }}</p>
                </div>
              </div>

              <div class="div_hr bg-color-blue-light my-2"></div>

              <div class="d-flex justify-space-between align-items-center px-2">
                <p class="font-5">شماره سفارش</p>
                <p class="font-5 font-bold">{{ item.order_code }}</p>
              </div>

              <div class="div_hr bg-color-blue-light my-2"></div>

              <div class="d-flex justify-space-between align-items-center px-2">
                <p class="font-5">مبلغ کل سفارش</p>
                <p class="font-5 font-bold d-flex">
                  <span class="">{{ item.amount_total.toLocaleString() }}</span>
                  <span class="mr-1">تومان</span>
                </p>
              </div>

              <div class="div_hr bg-color-blue-light my-2"></div>

              <div class="d-flex justify-space-between align-items-center px-2">
                <p class="font-5">مبلغ کسر شده بابت کمیسیون</p>
                <p class="font-5 font-bold d-flex">
                  <span class="">{{ item.amount_dec.toLocaleString() }}</span>
                  <span class="mr-1">تومان</span>
                </p>
              </div>

              <div class="d-flex align-items-center bg-color-blue-light rounded-3 p-2 mt-3">
                <p class="font-5">وضعیت تسویه :</p>
                <p :class="item.checkout === 'تسویه شده' ? 'font-color-green':'font-color-red'" class="font-5 font-bold mr-1">{{ item.checkout }}</p>
              </div>
            </div>

          </div>

          <div v-else style="height: 70vh" class="d-flex w-100 animate__animated animate__fadeIn">
            <div class="d-flex flex-column align-items-center justify-content-center">
              <img src="../assets/img/payment.png" class="mb-4 w-40 icon_shadow" alt="">
              <p class="font-4 font-bold">تاریخچه کیف پول شما در حال حاضر خالی است!</p>
            </div>
          </div>
        </div>

        <div v-if="page === 'cheque' " class="overflow-hidden p-3">

          <div v-if="cheque_history.length !== 0" style="height: 70vh" class="overflow-y-scroll">

            <div v-for="item in cheque_history" :key="item.id" class="animate__animated animate__fadeInRight mb-3 p-body py-3 bg-white rounded-4 shadow-custom">
              <div class="d-flex justify-content-between align-items-center ">
                <div class="d-flex justify-content-center align-items-center">
                  <img v-if="item.checkout === 'تسویه شده' " class="ml-2 icon-size-2" src="../assets/img/plusgreen.svg">
                  <img v-else src="../assets/img/plus_cheque.svg" class="ml-2 icon-size-2">

                  <div class="d-flex" :class="item.checkout === 'تسویه شده' ? 'font-color-green':'text-uppercase'">
                  <p class="mx-1 font-4 ">{{ item.amount.toLocaleString() }}</p>
                  <p class="font-5 ">تومان</p>
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <p class="m-0 ms-2 font-5">{{ item.date }}</p>
                  <p class="m-0 font-5">{{ item.time }}</p>
                </div>
              </div>

              <div class="div_hr bg-color-blue-light my-2"></div>

              <div class="d-flex justify-space-between align-items-center px-2">
                <p class="font-5">شماره سفارش</p>
                <p class="font-5 font-bold">{{ item.order_code }}</p>
              </div>

              <div class="div_hr bg-color-blue-light my-2"></div>

              <div class="d-flex justify-space-between align-items-center px-2">
                <p class="font-5">مبلغ کل سفارش</p>
                <p class="font-5 font-bold d-flex">
                  <span class="">{{ item.amount_total.toLocaleString() }}</span>
                  <span class="mr-1">تومان</span>
                </p>
              </div>

              <div class="div_hr bg-color-blue-light my-2"></div>

              <div class="d-flex justify-space-between align-items-center px-2">
                <p class="font-5">مبلغ کسر شده بابت کمیسیون</p>
                <p class="font-5 font-bold d-flex">
                  <span class="">{{ item.amount_dec.toLocaleString() }}</span>
                  <span class="mr-1">تومان</span>
                </p>
              </div>


              <div style="height: 11rem" class="d-flex justify-space-between p-2 drop_shadow shadow-custom rounded-4 mt-5">
                <div class="w-60 d-flex flex-column h-100 justify-content-between">
                  <div class="d-flex justify-space-between align-items-center">
                    <p class="font-5 font-color font-bold">تاریخ چک</p>

                    <p class="font-5">{{ item.cheque.date }}</p>
                  </div>

                  <div class="hr my-3"></div>

                  <div class="d-flex justify-space-between align-items-center">
                    <p class="font-5 font-color font-bold">بانک صادر کننده</p>

                    <p class="font-5">{{ item.cheque.bank }}</p>
                  </div>

                  <div class="hr my-3"></div>

                  <div class="d-flex justify-space-between align-items-center">
                    <p class="font-5 font-color font-bold">شماره چک</p>

                    <p class="font-5">{{ item.cheque.sayad }}</p>
                  </div>
                </div>

                <div class="w-35 d-flex flex-column justify-content-between h-100">
                  
                  <div style="height: 7rem" class="animated-background rounded-3 w-100">
                    <img class="w-100 h-100 rounded-3" :src="item.cheque.pic" alt="">
                  </div>

                  <div class="d-flex justify-center">
                    <p @click="open_cheque(item.cheque.pic)" class="bg-color text-white font-6 py-1 px-2 rounded-pill">بزرگنمایی تصویر</p>
                  </div>
                  
                </div>
              </div>


              <div class="d-flex align-items-center bg-color-blue-light rounded-3 p-2 mt-3">
                <p class="font-5">وضعیت تسویه :</p>
                <p :class="item.checkout === 'تسویه شده' ? 'font-color-green':'font-color-red'" class="font-5 font-bold mr-1">{{ item.checkout }}</p>
              </div>
            </div>

          </div>

          <div v-else style="height: 70vh" class="d-flex w-100 animate__animated animate__fadeIn">
            <div class="d-flex flex-column align-items-center justify-content-center">
              <img src="../assets/img/dont_cheque.png" class="mb-4 w-40 icon_shadow" alt="">
              <p class="font-4 font-bold">در حال حاضر چکی دریافت نکرده اید!</p>
            </div>
          </div>
        </div>


      </div>
    </div>




        <div v-if="dialog" id="dialog" class="animate__animated animate__fadeIn dialog max_width p-body">
            <div class="bg-white rounded-4">

                <div style="height: 45px"
                     class="bg-color d-flex justify-content-center align-items-center rounded-top-4 text-center position-relative">
                    <img style="height: 10vh;left: 0" class="position-absolute bottom-0"
                         src="../assets/img/icon_record_card.svg" alt="">
                    <p class="text-white font-4">ثبت کارت</p>
                </div>

                <div class="p-3">
                    <p class="font-5 text-center mb-3">جهت تسویه و پرداخت لطفا شماره کارت خود را به اپلیکیشن اضافه کنید</p>

                    <div class="mb-3">
                        <p class="font-4 font-bold font-color mb-2">نام صاحب کارت</p>

                        <input v-model="add_card.name" :disabled="details_card" class="shadow-custom p-3 text-center font-4 rounded-4 w-100" placeholder="نام شخض حقیقی یا حقوقی" type="text">
                    </div>

                    <div class="mb-3">
                        <p class="font-4 font-bold font-color mb-2">نام بانک</p>

                        <input v-model="add_card.bankname" :disabled="details_card" class="shadow-custom p-3 text-center font-4 rounded-4 w-100" placeholder="مثلا بانک ملی" type="text">
                    </div>

                    <div class="mb-3">
                        <p class="font-4 font-bold font-color mb-2">شماره شبا مورد نظر را وارد نمایید</p>

                        <div class="position-relative">
                            <p style="left: 5%;top: 50%;transform: translate(0, -50%);" class="font-bold font-4 font-color position-absolute">IR</p>

                            <input v-model="add_card.shaba" :disabled="details_card" class="shadow-custom p-3 text-center font-4 rounded-4 w-100" placeholder="شماره شبا" maxlength="24" type="tel">
                        </div>
                    </div>

                    <div class="mb-3">
                        <p class="font-4 font-bold font-color mb-2">شماره حساب مورد نظر را وارد نمایید</p>

                        <input v-model="add_card.account" :disabled="details_card" class="shadow-custom p-3 text-center font-4 rounded-4 w-100" maxlength="18" placeholder="شماره حساب" type="tel">
                    </div>

                    <div class="mb-4">
                        <p class="font-4 font-bold font-color mb-2">شماره کارت مورد نظر را وارد نمایید</p>

                        <input v-model="add_card.card" :disabled="details_card" class="shadow-custom p-3 text-center font-4 rounded-4 w-100" maxlength="16" placeholder="شماره کارت"
                               type="tel">
                    </div>

                    <div v-if="!details_card" class="d-flex justify-content-center align-items-center">
                        <v-btn @click="add_cards"  class="w-100 h-100 bg-color rounded-4 shadow-custom text-white p-3 font-4">ارسال</v-btn>
                    </div>

                </div>
            </div>
        </div>

        <div v-if="show_cheque.action" @click="open_cheque" class="d-flex justify-center align-items-center position-fixed top-0 w-100 max_width" style="height: 100vh;z-index: 6">
          <img id="img_cheque" class="img_cheque animate__animated animate__fadeIn" :src="show_cheque.src" alt="">
        </div>

  </div>

</template>


<style scoped>

.list_address {
  max-height: 23vh;
  overflow-y: scroll;
}

.div_hr {
  width: 100%;
  height: 3px;
}
.hr{
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}
.dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  z-index: 5;
}
.drop_shadow {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 0px 55px -12px inset, rgba(0, 0, 0, 0.3) 0px 0px 0px 0px inset, inset 0 0 15px 0 #c7c7c7;
}
.img_cheque{
  max-width: 95%;
  max-height: 50vh;
}
.shadow_select {
  box-shadow: 0 -7px 15px -5px #707070;
}

</style>